import React from 'react';

const Pencil = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.66667 2.66667L11.3333 4.33333M1 13L4.33333 12.3333L12.0447 4.62199C12.5654 4.10129 12.5654 3.25707 12.0447 2.73637L11.2636 1.95526C10.7429 1.43456 9.89871 1.43456 9.37801 1.95526L1.66667 9.66667L1 13Z"
                stroke={color || '#A7A7A8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Pencil;
